module.exports = __webpack_public_path__ + "img/liberrex-grayscale.412ef437.png";